import type { PartialTtsData } from '../types';
import TtsWordBoundariesStore from './stores/TtsWordBoundariesStore';

const ttsWordBoundariesStore = new TtsWordBoundariesStore();

export function getTtsWordBoundaries(
  documentId: string,
  voice: string,
): Promise<PartialTtsData[string] | null> {
  return ttsWordBoundariesStore.get(documentId, voice);
}

export function mergeTtsWordBoundaries(
  documentId: string,
  voice: string,
  data: PartialTtsData[string],
): Promise<PartialTtsData[string]> {
  return ttsWordBoundariesStore.merge(documentId, voice, data);
}

export function clearTtsWordBoundariesCache(): Promise<void> {
  return ttsWordBoundariesStore.clearCache();
}
